import { useState, useEffect } from "react";
import RichTextEditor from "../../../common/richTextEditor";
import { BaseUrl } from "../../../common/config";
import ConfirmationPopup from "../../../common/confirmationPopup";
import { useTranslation } from "react-i18next";
import { canAction } from "../../../common/permissionhelper";
const MODULE = "manage_foodservicepartners";
const HomePageBannerEditor = ({ section, onUpdate, onSave, isSaving }) => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit;
  const [showImageDeletePopup, setShowImageDeletePopup] = useState(false);
  const [formData, setFormData] = useState(
    section || {
      title: "",
      description: "",
      buttonText: "",
      imageUrl: "",
      imageFile: null,
      isVisible: "true"
    }
  );
  // Load section data into form when section prop changes
  useEffect(() => {
    if (section) {
      setFormData({
        ...section,
      });
    }
  }, [section]);
  // Handle changes for text inputs and rich text editor
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = {
      ...formData,
      [name]: name === "isVisible" ? value === "true" : value,
    };
    updateParent(updatedData);
  };
  // Handle rich text editor change separately to get HTML content
  const handleRichTextChange = (html) => {
    const updatedData = {
      ...formData,
      description: html,
    };
    updateParent(updatedData);
  };
  const handleTitleChange = (html) => {
    const updatedData = {
      ...formData,
      title: html,
    };
    updateParent(updatedData);
  };
  // Handle image upload and preview
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    const updatedData = {
      ...formData,
      imageFile: file, // actual file for backend
      imageUrl: previewUrl, // preview only
    };
    updateParent(updatedData);
  };
  // Update parent component with new form data
  const updateParent = (updatedData) => {
    setFormData(updatedData);
    onUpdate && onUpdate(updatedData);
  };
  // Handle image removal
  const handleRemoveImage = () => {
    const updatedData = {
      ...formData,
      imageUrl: "",
      imageFile: null,
    };
    setFormData(updatedData);
    onUpdate && onUpdate(updatedData);
  };
  // Rendering logic
  return (
    <div className="section-editor">
      <div className="input-field">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <label>Show banner on home page?</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <div className="radio-box">
              <input
                type="radio"
                id="yes"
                name="isVisible"
                value="true"
                checked={formData.isVisible === true}
                onChange={(e) => {
                  if (isReadOnly) {
                    e.preventDefault();
                    return;
                  }
                  handleChange(e);
                }}
              />
              <label htmlFor="yes">Yes</label>
            </div>
            <div className="radio-box">
              <input
                type="radio"
                id="no"
                name="isVisible"
                value="false"
                checked={formData.isVisible === false}
                onChange={(e) => {
                  if (isReadOnly) {
                    e.preventDefault();
                    return;
                  }
                  handleChange(e);
                }}
              />
              <label htmlFor="no">No</label>
            </div>
          </div>
        </div>
      </div>
      {/* Section Title */}
      <div className="input-field">
        <label>{t("section_title_txt")}</label>
        <RichTextEditor
          emailContent={formData.title || ""}
          handleChangeEmailContent={handleTitleChange}
          readOnly={isReadOnly}
        />
      </div>
      {/* Description */}
      <div className="input-field">
        <label>{t("section_description_txt")}</label>
        <RichTextEditor
          emailContent={formData.description || ""}
          handleChangeEmailContent={handleRichTextChange}
          readOnly={isReadOnly}
        />
      </div>
      {/* Button Text */}
      <div className="input-field">
        <label>{t("button_text_txt")}</label>
        <input
          type="text"
          name="buttonText"
          value={formData.buttonText || ""}
          onChange={handleChange}
          readOnly={isReadOnly}
        />
      </div>
      {/* Image Upload */}
      {/* <div className="notification-field-set grow-cms-field-set">
        <div className="input-field">
          <label>
            {t("section_image_txt")}{" "}
            <span className="text-note">{t("imgage_only_allowed_txt")}</span>
          </label>
          <div className="flex align-center gap-10">
            {!formData.imageUrl && (
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleImageUpload}
              />
            )}
            {formData.imageUrl && (
              <div className="upld-img-file">
                <div className="upld-img-show">
                  <img
                    src={
                      formData.imageFile
                        ? URL.createObjectURL(formData.imageFile)
                        : `${BaseUrl}${formData.imageUrl}`
                    }
                    alt="Preview"
                  />
                  <a
                    className="title-tooltip title-up delete-img"
                    data-title={t("delete_txt")}
                    onClick={() => setShowImageDeletePopup(true)}
                  >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div> */}
      {/* Save Button */}
      {!isReadOnly && (
      <div className="btnfield" style={{ marginTop: "20px" }}>
        <button
          type="button"
          onClick={() => onSave && onSave("homepagebanner", formData)}
          disabled={isSaving}
        >
          {isSaving ? t("saving_txt") : t("save_section_txt")}
        </button>
      </div>
      )}
      {/* Image Delete Confirmation */}
      {showImageDeletePopup && (
        <ConfirmationPopup
          title={t("confirm_txt")}
          confirmationMessage={t("dlt_homepage_banner_image_confirm_txt")}
          handleYes={() => {
            handleRemoveImage();
            setShowImageDeletePopup(false);
          }}
          handleNo={() => setShowImageDeletePopup(false)}
        />
      )}
    </div>
  );
};

export default HomePageBannerEditor;